import { render, staticRenderFns } from "./firmDeposit.vue?vue&type=template&id=638def70&scoped=true&lang=pug"
import script from "./firmDeposit.vue?vue&type=script&lang=js"
export * from "./firmDeposit.vue?vue&type=script&lang=js"
import style0 from "./firmDeposit.vue?vue&type=style&index=0&id=638def70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638def70",
  null
  
)

export default component.exports